import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.loading.spinner');
import { Input } from '@angular/core';

@Component({
    selector: 'wiz-component-loading-spinner',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.loading.spinner/view.scss */
:host {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: auto;
  height: auto;
  line-height: 0;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
}

.inline-loading-spinner {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  color: currentColor;
}

.inline-loading-spinner.sm {
  width: 14px;
  height: 14px;
}

.inline-loading-spinner.lg {
  width: 34px;
  height: 34px;
}

.inline-loading-spinner-dot {
  width: 100%;
  height: 100%;
  border: 2px solid currentColor;
  border-top-color: transparent;
  border-radius: 999px;
  animation: inline-spinner-rotate 0.7s linear infinite;
  opacity: 0.9;
}

.inline-loading-spinner.lg .inline-loading-spinner-dot {
  border-width: 3px;
}

@keyframes inline-spinner-rotate {
  to {
    transform: rotate(360deg);
  }
}`],
})
export class ComponentLoadingSpinnerComponent {
    @Input() public label: string = '로딩 중';
    @Input() public size: 'sm' | 'md' | 'lg' | string = 'md';
    @Input() public className: string = '';
}

export default ComponentLoadingSpinnerComponent;